export const request = (input: RequestInfo | URL, init?: RequestInit) =>
  fetch(input, init).then((res) => (res.ok ? Promise.resolve(res) : Promise.reject(res)))
